import { render, staticRenderFns } from "./ActiveCustomer.vue?vue&type=template&id=995f51cc"
import script from "./ActiveCustomer.vue?vue&type=script&lang=js"
export * from "./ActiveCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('995f51cc')) {
      api.createRecord('995f51cc', component.options)
    } else {
      api.reload('995f51cc', component.options)
    }
    module.hot.accept("./ActiveCustomer.vue?vue&type=template&id=995f51cc", function () {
      api.rerender('995f51cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/ActiveCustomer.vue"
export default component.exports